import dayjs from 'dayjs';

const isToday = (date: Date | string) => {
  return dayjs(new Date(date)).format('MM/DD/YYYY') === dayjs().format('MM/DD/YYYY');
};

export default isToday;
